module.exports = __webpack_public_path__ + "static/media/2.5ac4f002.jpg";